<template>
  <div class="ConnecticutNotice">
    <h2 class="ConnecticutNotice_Heading">
      PRIVACY NOTICE FOR CONNECTICUT RESIDENTS
    </h2>

    <p>If you are a Connecticut resident, you have the following rights:</p>

    <p>
      <span class="ConnecticutNotice_ItemTitle">Right to Access:</span>
      You may have the right to confirm whether or not we are processing your
      Personal Information and to access such Personal Information.
    </p>

    <p>
      <span class="ConnecticutNotice_ItemTitle">Right to Correction:</span>
      You may have the right to correct inaccuracies in your Personal
      Information, taking into account the nature of the Personal Information
      and the purposes of the processing of your Personal Information.
    </p>

    <p>
      <span class="ConnecticutNotice_ItemTitle">Right to Deletion:</span>
      You may have the right to delete the Personal Information provided to us
      by you.
    </p>

    <p>
      <span class="ConnecticutNotice_ItemTitle"
        >Right to Data Portability:</span
      >
      You may have the right to obtain a copy of the Personal Information that
      you previously provided to us in a portable and, to the extent technically
      feasible, readily usable format that allows you to transmit your Personal
      Information to another controller without hindrance, where the processing
      is carried out by automated means.
    </p>

    <p>
      <span class="ConnecticutNotice_ItemTitle"
        >Right to Opt-Out of Sale, Targeted Advertising, and Profiling:</span
      >
      For purposes of the CTDPA, a “sale” includes disclosing Personal
      Information to a third party in exchange for monetary compensation or
      other valuable consideration. Grove Collaborative does not “sell” Personal
      Information under this definition. We do share your Personal Information
      for targeted advertising purposes as we describe in the Privacy Policy to
      make the Service available to you. For example, we may disclose
      information to advertising partners, advertising technology companies, and
      companies that perform advertising-related services in order to improve
      the relevance of our advertising and marketing. To the extent possible,
      Grove Collaborative excludes Personal Information from Connecticut
      residents from these activities. Connecticut residents have the right to
      opt out of the processing of your Personal Information by us for decisions
      that produce legal or similarly significant effects concerning you. We do
      not process Personal Information for such profiling.
    </p>

    <p>
      <span class="ConnecticutNotice_ItemTitle">Right to Appeal:</span>
      If you are a resident of Connecticut and wish to exercise any of your
      rights under the CTDPA, you or your authorized agent may make a request to
      confirm, access, correct, delete, obtain a copy, or opt-out of the
      processing of your Personal Information for targeting advertising by
      submitting a Privacy Request Form
      <SkyLink
        inline
        to="https://preferences.grove.co/privacy"
        target="_blank"
        tag="a"
        >here</SkyLink
      >, or by emailing
      <SkyLink inline to="mailto:support@grove.co" tag="a"
        >support@grove.co.</SkyLink
      >
      Please indicate that you are making a request pursuant to your
      “Connecticut Privacy Rights” and provide us with the requested information
      to verify your request. We will take steps to verify your request by
      matching the information provided by you with the information we have in
      our records.
    </p>
  </div>
</template>

<style lang="scss">
.ConnecticutNotice {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
    text-align: center;
  }

  &_ItemTitle {
    text-decoration: underline;
  }
}
</style>
